import { render, staticRenderFns } from "./bj-unit-schedule-tour.vue?vue&type=template&id=ea4a1d48&scoped=true&"
import script from "./bj-unit-schedule-tour.vue?vue&type=script&lang=js&"
export * from "./bj-unit-schedule-tour.vue?vue&type=script&lang=js&"
import style0 from "./bj-unit-schedule-tour.vue?vue&type=style&index=0&id=ea4a1d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4a1d48",
  null
  
)

component.options.__file = "bj-unit-schedule-tour.vue"
export default component.exports